import * as React from "react";

import { TableHead, TableRow } from "@material-ui/core";

import {
  ButtonTableCell,
  StyledTableCell
} from "../../../components/sharedStyledComponents";

export const UserTableHeader: React.FunctionComponent = () => (
  <TableHead>
    <TableRow>
      <StyledTableCell>Name</StyledTableCell>
      <StyledTableCell>Email</StyledTableCell>
      <StyledTableCell>Mobile</StyledTableCell>
      <ButtonTableCell />
    </TableRow>
  </TableHead>
);
